








































































import { defineComponent, ref, computed, PropType } from '@vue/composition-api';
import { EditSidePayload, EpigraphicUnitSide } from '@oare/types';
import sl from '@/serviceLocator';

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    textUuid: {
      type: String,
      required: true,
    },
    usableSides: {
      type: Array as PropType<EpigraphicUnitSide[]>,
      required: true,
    },
    alreadyUsedSides: {
      type: Array as PropType<EpigraphicUnitSide[]>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const editSideLoading = ref(false);

    const originalSide = ref<EpigraphicUnitSide | null>(null);
    const newSide = ref<EpigraphicUnitSide | null>(null);

    const formComplete = computed(() => originalSide.value && newSide.value);

    const editSide = async () => {
      try {
        editSideLoading.value = true;

        if (!originalSide.value || !newSide.value) {
          throw new Error('Required side designations not provided');
        }

        const payload: EditSidePayload = {
          type: 'editSide',
          textUuid: props.textUuid,
          originalSide: originalSide.value,
          newSide: newSide.value,
        };
        await server.editText(payload);
        emit('reset-renderer');
        emit('selected-side', newSide.value);
      } catch (err) {
        actions.showErrorSnackbar(
          'Error editing side designation. Please try again.',
          err as Error
        );
      } finally {
        editSideLoading.value = false;
        emit('reset-current-edit-action');
        emit('input', false);
      }
    };

    return {
      editSideLoading,
      originalSide,
      newSide,
      formComplete,
      editSide,
    };
  },
});
